<template>
  <div>
    <v-row class="profile-section right-panel dialog-cls center-content ma-0">
      <v-col
        :cols="
          $vuetify.breakpoint.mdAndUp ? 3 : $vuetify.breakpoint.xsOnly ? 12 : 12
        "
        class="border-right"
      >
        <v-row justify-sm="start" class="ma-0">
          <v-col cols="12" class="pa-0">
            <image-section :profile="profile" />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        :cols="
          $vuetify.breakpoint.mdAndUp ? 9 : $vuetify.breakpoint.xsOnly ? 12 : 12
        "
        :class="$vuetify.breakpoint.smOnly ? 'tab-height' : ''"
        class="pa-4"
      >
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <edit-profile-information
              :profileInfo="user"
            ></edit-profile-information>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ImageSection from "./ImageSection";
import { mapGetters } from "vuex";
import EditProfileInformation from "./EditProfileInformation.vue";
import { ProfileService } from "@/services";

export default {
  name: "ProfileSection",
  components: {
    EditProfileInformation,
    ImageSection,
  },
  data() {
    return {
      profile: {},
      tab: null,
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "user",
    }),
    // eslint-disable-next-line vue/return-in-computed-property
    itemsPerRow() {
      // eslint-disable-next-line default-case
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 2;
        case "md":
          return 2;
        case "lg":
          return 3;
        case "xl":
          return 3;
      }
    },
  },
  created() {
    this.profileInformation();
  },
  methods: {
    async profileInformation() {
      const response = await ProfileService.getProfile();
      if (response.data) {
        this.profile = response.data;
      }
    },
 /*    updatedAddressArr(addressArr) {
      this.profile.address = [];
      this.profile.address = [...addressArr];
    }, */
  },
};
</script>
<style scoped>
.border-right {
  border-right: 1px solid #e1e1e1;
}
.border-bottom {
  border-bottom: 1px solid #e1e1e1;
}
.profile-section {
  height: calc(100vh - 90px);
}
</style>
